// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__304LR","messages":"Chat_messages__3t4F5","dateDivider":"Chat_dateDivider__1kJwV"};